var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.$style.title,attrs:{"data-test":_vm.dataTestTitle,"title":_vm.title}},[_vm._v(_vm._s(_vm.truncatedTitle))]),(_vm.subtitle)?_c('div',{class:_vm.$style.subtitle},[_vm._v(" "+_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }